<template>
  <div class="income-detail" @click="transClass($event)">
    <DayDetail :closePop="closePop"></DayDetail>
    <WorkDetail></WorkDetail>
  </div>
</template>

<script>
import DayDetail from './components/incomeData/dayDetail';
import WorkDetail from './components/incomeData/workDetail';
export default {
  name: 'DataDetail',
  components: {
    DayDetail,
    WorkDetail,
  },
  data() {
    return {
      closePop: 0,
    };
  },
  methods: {
    transClass(e) {
      if (e.target.className == 'th-title' || e.target.className == 'th-img') {
        return false;
      } else {
        this.closePop = Math.random();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.income-detail {
  color: #262626;
  font-size: 24px;
  .day-detail,
  .work-detail {
    padding: 20px;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 10px;
    .table-title {
      font-size: 28px;
      margin-bottom: 31px;
    }
  }
  .day-detail {
    .content {
      .btn-label {
        margin-bottom: 30px;
        span {
          font-size: 26px;
          padding: 10px;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          margin-right: 9px;
        }
        .active {
          background: #fffaed;
          border: 1px solid #ffc973;
          color: #fd9b21;
        }
      }
      .select-date {
        font-size: 26px;
        display: flex;
        align-items: center;
        .date-wrap {
          height: 56px;
          display: flex;
          align-items: center;
          margin-left: 35px;
          border: 1px solid #d9d9d9;
          padding: 0 10px;
          div {
            margin: 0 20px;
            i {
              color: #bfbfbf;
              font-size: 24px;
            }
          }
          span {
            color: #bfbfbf;
          }
        }
      }
    }
  }
}
</style>
